<template>
  <div id="DaneWejsciowe">
    <h4>{{$t('message.input_data')}}</h4>
    <form>
      <div class="form-group">
        <label for="czas_podtrzymania">{{$t('message.czas_podtrzymania')}}</label>
        <select class="form-control form-control-sm" id="czas_podtrzymania"
        v-model="inputData.czas_podtrzymania.value"
        @change="changeInputs('czas_podtrzymania')">
          <option v-for="item in config.czas_podtrzymania.value" :value="item" :key="item">{{item}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="czas_alarmowania">{{$t('message.czas_alarmowania')}}</label>
        <!-- <input type="text" class="form-control form-control-sm" value="0.5" id="czas_alarmowania" -->
        <input type="text" class="form-control form-control-sm" value="0.5" id="czas_alarmowania"
        v-model="inputData.czas_alarmowania.value"
        readonly>
        <!-- <input type="text" class="form-control form-control-sm" value="0.5" id="czas_alarmowania"
        v-model="inputData.czas_alarmowania.value"
        readonly> -->
      </div>
      <div class="form-group">
        <label for="dodatkowe_u">{{$t('message.dodatkowe_u')}}</label>
        <input type="number" value="0" :min="inputs.dodatkowe_u.min" :max="inputs.dodatkowe_u.max" class="form-control form-control-sm" id="dodatkowe_u"
        v-model="inputData.dodatkowe_u.value"
        @change="checkValue('dodatkowe_u')">
      </div>

      <div class="form-group">
        <label for="glebokosc_szafy" style="width:198px">{{$t('message.glebokosc_szafy')}}</label>
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
          <md-tooltip md-direction="right" class="tooltipShort" v-html="$t('message.glebokosc_szafy_info')"></md-tooltip>
        </md-avatar>
        <select class="form-control form-control-sm" id="glebokosc_szafy"
        :disabled = !check_depth
        v-model="inputData.glebokosc_szafy.value"
        @change="changeInputs('glebokosc_szafy'), changeDepthCabinet()">
          <option v-for="item in config.glebokosc.value" :value="item" :key="item">{{item}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="sieciowanie_systemu" style="width:198px">{{$t('message.sieciowanie')}}</label>
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill iconInfo" viewBox="0 0 16 16" style="">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
          <md-tooltip md-direction="right" class="tooltipShort" v-html="$t('message.sieciowanie_info')"></md-tooltip>
        </md-avatar>
        <select class="form-control form-control-sm" id="sieciowanie_systemu"
        v-model="inputData.sieciowanie_systemu.value"
        @change="changeInputs('sieciowanie_systemu')">
          <option v-for="item in config.sieciowanie.value" :value="item" :key="item">{{$t('message.' + item)}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="tryb_poboru_mocy" style="line-height:15px;padding: 2px;">{{$t('message.tryb_poboru')}}</label>
        <select class="form-control form-control-sm" id="tryb_poboru_mocy"
        v-model="inputData.tryb_poboru_mocy.value"
        @change="changeInputs('tryb_poboru_mocy')">
          <option v-for="item in config.tryb_poboru.value" :value="item" :key="item">{{item}}</option>
        </select>
      </div>
    </form>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'DaneWejsciowe',
  mixins: [app, materials, calculation],
  data () {
    return {
      inputData: {
        czas_podtrzymania: {'value': 24},
        // czas_alarmowania: {'value': 1},
        czas_alarmowania: {'value': 0.5},
        dodatkowe_u: { 'value': 0, 'min': 0, 'max': 50 },
        glebokosc_szafy: {'value': 600, 'active': 0},
        sieciowanie_systemu: {'value': 'nie'},
        tryb_poboru_mocy: {'value': 'standby'}
      }
    }
  },
  computed: {
    ...mapGetters('app', ['selected_input']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy']),

    check_depth () {
      return this.config.glebokosc.value > 1 ? 0 : 1
    }
  },
  watch: {
    inputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.inputData).forEach(element => {
          this.inputData[element]['value'] = newValue[element].value
        })
      }
    }
  },
  methods: {
    changeDepthCabinet () {
      console.log('----- changeDepthCabinet -----')
      var glebokosc = this.inputData.glebokosc_szafy.value
      var wysokosc = this.outputs.szafa.attributes.wysokosc
      var matchSzafa = []
      matchSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc === wysokosc && item.attributes.glebokosc === glebokosc))
      this.changeValueOutputs('szafa', 'array', matchSzafa[0])
      this.changeValueInputs('glebokosc_szafy', 'active', true)
      this.changeValueInputs('glebokosc_szafy', 'value', this.inputData.glebokosc_szafy.value)
      this.obliczenia_sprzetu()
    }
  }
}
</script>

<style scoped>
.iconInfo {
 margin-right: 4px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;
}
.iconInfo:hover {
  background: #3ba3ff; color: #fff; border: 2px;  border: 1px solid #3ba3ff;
}
  #DaneWejsciowe {
    height: 205px;
  }

  .md-avatar {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
  }

  .tooltipShort  {
    padding:10px;
    width:235px;
    height:65px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DaneWejsciowe.vue